import { createReducer, on } from '@ngrx/store';
import * as fromTeamActions from '../actions/teams.actions';
import { Team } from '../../models/team.models';

export interface TeamState {
    data: Team[];
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: TeamState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const teamReducer = createReducer(
    initialState,
    on(fromTeamActions.LoadTeamsAction, (state) => ({ ...state, loading: true })),
    on(fromTeamActions.LoadTeamsSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTeamActions.LoadTeamsFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTeamActions.AddTeamAction, (state) => ({ ...state, loading: true })),
    on(fromTeamActions.AddTeamSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTeamActions.AddTeamFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTeamActions.DeleteTeamAction, (state) => ({ ...state, loading: true })),
    on(fromTeamActions.DeleteTeamSuccessAction, (state) => ({ ...state, data: undefined as any, loaded: true, loading: false })),
    on(fromTeamActions.DeleteTeamFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTeamActions.UpdateTeamAction, (state) => ({ ...state, loading: true })),
    on(fromTeamActions.UpdateTeamSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTeamActions.UpdateTeamFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
